import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { OperationentityProductMappingSchemaObject } from '../OperationentityProductMappingSchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';

const screenCode = 'PRODUCTTOOPERATIONS';

export function OperationentityProductMappingAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Operationentity Product Mapping");
    const [buttonText, setButtonText] = useState("Add");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [product, setProduct] = useState();
    const [operationEntityProductMappingData, setOperationEntityProductMappingData] = useState([]);
    const [operationEntityProductMapping, setOperationEntityProductMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        productID: '0',
        isActive: true
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });

    const schema = Joi.object(OperationentityProductMappingSchemaObject).options({ allowUnknown: true });
    
    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [operationEntityProductMapping.groupID]);

    useEffect(() => {
        trackPromise(
            getProductsForDropDown()
            )
    }, [operationEntityProductMapping.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITPRODUCT');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }
        
        if (data && edit) {
            setTitle("Edit Operationentity Product Mapping");
            data.isActive === true ? setButtonText("Deactivate") : setButtonText("Active");
            fillOperationEntityProductEditdata();
        } else {
            setTitle("Add Operationentity Product Mapping");
        }

        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(operationEntityProductMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getProductsForDropDown() {
        var products = [];
        if (edit && data) {
            products = await services.getAvialableProducts(operationEntityProductMapping.operationEntityID);
        } else {
            products = await services.getUnsusedProducts(operationEntityProductMapping.operationEntityID);
        }
        setProduct(products);
    }

    async function fillOperationEntityProductEditdata() {

        const selectedOperationEntity = await services.getOperationEntityByID(data.operationEntityID);

        if (selectedOperationEntity) {
            setOperationEntityProductMapping({
                ...operationEntityProductMapping,
                groupID: selectedOperationEntity.groupID.toString(),
                operationEntityID: data.operationEntityID.toString(),
                productID: data.productID.toString(),
                isActive: data.isActive
            })
        }
    }

    function validateInputs(target){
        const error = { ...errors }
        const errorMessage = validateProperty(target, OperationentityProductMappingSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error);
    }

    function handleGroupChange(target){
        validateInputs(target);

        setOperationEntityProductMapping({
            ...operationEntityProductMapping,
            groupID: target.value,
            operationEntityID: "0",
            productID: "0"
        });
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setOperationEntityProductMapping({
            ...operationEntityProductMapping,
            operationEntityID: target.value,
            productID: "0"
        });
    }

    function handleProductChange(target){
        validateInputs(target);

        setOperationEntityProductMapping({
            ...operationEntityProductMapping,
            productID: target.value,
        });
    }

    function handleActiveChange(target) {
        validateInputs(target);
    
        setOperationEntityProductMapping({
            ...operationEntityProductMapping,
          isActive: target.checked,
        });
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, operationEntityProductMapping);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            var result = await services.AddOperationEntityProductMapping(operationEntityProductMapping);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        } else if (edit) {
            var result = await services.EditOperationEntityProductMapping(data.operationEntityProductID);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/opproductmapping' })
            }, 1500);
        }
    }

    function clearState() {
        setOperationEntityProductMapping({
            ...operationEntityProductMapping,
            groupID: '0',
            operationEntityID: '0',
            productID: '0',
        });
        setOperationEntityProductMappingData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/opproductmapping"
                                    buttonText="Back to listing"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={operationEntityProductMapping.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={operationEntityProductMapping.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="productID">Product</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="productID"
                                            id="productID"
                                            name="productID"
                                            value={operationEntityProductMapping.productID}
                                            onChange={(e) => handleProductChange(e.target)}>
                                            <MenuItem value="0">--Select Product--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["productID"] && <FormHelperText error>{errors["productID"]}</FormHelperText>}
                                    </div>
                                </div>

                                {(edit && data) ? null :
                                    <div>
                                        <label>Active</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isActive"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isActive"
                                                    onChange={(e) => handleActiveChange(e.target)}
                                                    checked={operationEntityProductMapping.isActive}
                                                />
                                                <label htmlFor="isActive" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, operationEntityProductMapping)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonText}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}